// LOGGED IN CONSTANTS
export const LOGGED_IN_GREETING = "Hi";
export const LOGGED_IN_GREETING_WO_NAME = "Hello";
export const HAMBURGER_PROMPT_URL = "bajajsuperapp://hamburger";
export const LOGGED_IN_MY_ACC_URL =
  "/myaccountlogin?v1=/myaccountlogin&sso-module=cart&sso-product=Profile&sso-form-post=/SSO/SingleSignOn";

// NON LOGGED IN CONSTANTS
export const NON_LOGGED_IN_MY_ACC_URL =
  "/myaccountlogin?v1=/myaccountlogin&sso-module=myaccount&sso-product=Home&sso-form-post=/SSO/SingleSignOn";
